"use client";

import { c as _c } from "react/compiler-runtime";
import { displayDate } from "@repo/design-system/utils/date-helpers";
import { combineEmploymentTypes } from "@repo/design-system/utils/helpers";
import { formatSalaryRow, getSalaryState } from "@repo/design-system/utils/salary-display";
import { Fragment } from "react";
import PrivacyNotice from "~/components/job-page/jobadtemplate/privacy-notice-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
const INT_GRADUATE_IDS = ["230421", "232072", "232073", "232074", "232075", "232076", "232078", "232079", "232081", "232083"];
export default function DetailsBox(t0) {
  const $ = _c(58);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job.data.idClient) {
    t1 = INT_GRADUATE_IDS.includes(job.data.idClient);
    $[0] = job.data.idClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isIntGraduate = t1;
  const displayLocale = t.i18n === "de" ? "de" : "es";
  let t2;
  if ($[2] !== displayLocale || $[3] !== job.data.applicationEnd || $[4] !== t) {
    t2 = job.data.applicationEnd ? displayDate(job.data.applicationEnd.slice(0, 10), t, displayLocale) : null;
    $[2] = displayLocale;
    $[3] = job.data.applicationEnd;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const deadline = t2;
  let t3;
  if ($[6] !== job.content.compensationObject || $[7] !== t) {
    const salaryState = getSalaryState(job.content.compensationObject);
    t3 = formatSalaryRow(salaryState, t, t.i18n);
    $[6] = job.content.compensationObject;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const salaryRow = t3;
  let t4;
  if ($[9] !== job.data.contract || $[10] !== t.jobad_details_contractType) {
    t4 = {
      label: t.jobad_details_contractType,
      value: job.data.contract
    };
    $[9] = job.data.contract;
    $[10] = t.jobad_details_contractType;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = t.jobad_details_employmentType;
  let t6;
  if ($[12] !== job.data.employmentType || $[13] !== t) {
    t6 = combineEmploymentTypes(job.data.employmentType, t);
    $[12] = job.data.employmentType;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t.jobad_details_employmentType || $[16] !== t6) {
    t7 = {
      label: t5,
      value: t6
    };
    $[15] = t.jobad_details_employmentType;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== job.data.remote || $[19] !== t.jobad_details_remote) {
    t8 = {
      label: t.jobad_details_remote,
      value: job.data.remote
    };
    $[18] = job.data.remote;
    $[19] = t.jobad_details_remote;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== job.data.company || $[22] !== t.jobad_details_company) {
    t9 = {
      label: t.jobad_details_company,
      value: job.data.company
    };
    $[21] = job.data.company;
    $[22] = t.jobad_details_company;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== job.data.jobNumber || $[25] !== t.jobad_details_jobNumber) {
    t10 = {
      label: t.jobad_details_jobNumber,
      value: job.data.jobNumber
    };
    $[24] = job.data.jobNumber;
    $[25] = t.jobad_details_jobNumber;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== salaryRow) {
    t11 = salaryRow ? [salaryRow] : [];
    $[27] = salaryRow;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== deadline || $[30] !== job.data.applicationEnd || $[31] !== t.jobad_details_applicationDeadlineTitle) {
    t12 = job.data.applicationEnd ? [{
      label: t.jobad_details_applicationDeadlineTitle,
      value: deadline
    }] : [];
    $[29] = deadline;
    $[30] = job.data.applicationEnd;
    $[31] = t.jobad_details_applicationDeadlineTitle;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t4 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t13 = [t4, t7, t8, t9, t10, ...t11, ...t12];
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t4;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  const rows = t13;
  let t14;
  if ($[41] !== t.jobad_details_HL) {
    t14 = <h3 className="mb-6 font-bold text-2xl" data-source="lc">{t.jobad_details_HL}:</h3>;
    $[41] = t.jobad_details_HL;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== rows) {
    t15 = <dl className="mb-8 grid w-full grid-cols-2 break-words md:w-2/3 lg:w-full">{rows.map(_temp)}</dl>;
    $[43] = rows;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== salaryRow || $[46] !== t.salary_info_text_additional) {
    t16 = salaryRow && <p data-source="lc">{t.salary_info_text_additional}</p>;
    $[45] = salaryRow;
    $[46] = t.salary_info_text_additional;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== isIntGraduate || $[49] !== job.data.applicationEnd || $[50] !== t.jobad_details_applicationDeadline) {
    t17 = !(job.data.applicationEnd || isIntGraduate) && <p data-source="lc">{t.jobad_details_applicationDeadline}</p>;
    $[48] = isIntGraduate;
    $[49] = job.data.applicationEnd;
    $[50] = t.jobad_details_applicationDeadline;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <PrivacyNotice className="mt-4" />;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== t14 || $[54] !== t15 || $[55] !== t16 || $[56] !== t17) {
    t19 = <section className="my-10 bg-card p-10 text-base text-foreground leading-6 md:text-lg lg:my-6">{t14}{t15}{t16}{t17}{t18}</section>;
    $[53] = t14;
    $[54] = t15;
    $[55] = t16;
    $[56] = t17;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  return t19;
}
function _temp(row) {
  return <Fragment key={row.label}><dt className="py-2 align-top font-normal" data-source="lc">{row.label}:</dt><dd className="py-2 pl-2 align-top" data-source="job">{row.value}</dd></Fragment>;
}